
<div class="cmp-consent-checkboxes ws-specificity">
  <ws-checkbox
    v-if="forceRequired || !cart.termsAndConditionsConsent"
    v-model="termsAndConditionsConsent"
    class="full-width text-bold cy--consent-checkboxes--tos"
    :path="pathTos"
    :rules="[required]"
  >
    {{ $t('billing_profile.consent_tos.label') }}
    <a
      v-if="termsAndConditionsUrl"
      href="javascript:void(0)"
      target="_blank"
      class="ws-link"
      @click.prevent.stop="goToTos"
    >
      {{ $t('billing_profile.consent_tos.link') }}</a>
  </ws-checkbox>

  <ws-checkbox
    v-if="
      forceRequired ||
        (!isSwedishWorkflow &&
          cart.consentThirdPartyRequired &&
          !cart.thirdPartyConsent)
    "
    v-model="thirdPartyConsent"
    class="full-width text-bold cy--consent-checkboxes--third-party cy-consent-third-party"
    :path="pathThirdParty"
    :rules="[required]"
  >
    {{ $t('third_party.label') }}
    <a
      href="javascript:void(0)"
      class="ws-link"
      @click.prevent.stop="thirdPartyDialog = true"
    >
      {{ $t('third_party.link') }}</a>
  </ws-checkbox>

  <ws-modal
    v-model="thirdPartyDialog"
    :cfg="{ title: 'third_party.dialog.title' }"
  >
    <third-party-info />
  </ws-modal>
</div>
